module.exports = __webpack_public_path__ + "static/media/stat-guide-data-science-interviews.c1c490b3.md";